import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { FUNDING_ACCOUNT_NUMBER_BASE_PATH } from '../../../../../features/funding/account-number/funding-account-number-routing';

export const Route = createFileRoute('/_app/_clearing-core/funding/account-number/_account-number')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'funding-account-number-list',
        label: 'Funding',
        to: FUNDING_ACCOUNT_NUMBER_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
